import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from "notistack";

import {
  Typography,
  Grid,
  TextField,
  Autocomplete,
  Box,
  InputLabel,
  FormControl,
  Button,
  MenuItem,
  Select,
  IconButton,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/styles";

import { ArrowBackIosNew as ArrowBackIosNewIcon } from "@mui/icons-material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import thLocale from "date-fns/locale/th";

import { getEmployeesByCompany } from "../../../../../../actions/employee";
import { getDeliverySampleShuttleByNo } from "../../../../../../actions/deliverySampleshuttle";
import { getDeliverySampleshuttleByAdminFilter } from "../../../../../../actions/deliverySampleshuttle";
import { getUserProfile } from "../../../../../../actions/user";
import employeeService from "../../../../../../services/employee.service";
import userService from "../../../../../../services/user.service";
import SiteService from "../../../../../../services/site.service";
import deliverySampleshuttleService from "../../../../../../services/deliverySampleshuttle.service";

import DialogShowDetailDialog from "../../../../user/sampleshuttle/NewSample/dialogShowDetailBooking";
import Dropfile from "./Dropfile/index";

export const useStylesDeliverySampleForm = makeStyles((theme) => ({
  PaddingBottom: {
    paddingBottom: "0 !important",
  },
  Title: {
    textAlign: "center",
    fontSize: "18px",
  },

  HeadersText: {
    textAlign: "left",
    fontSize: "20px",
    marginTop: "15px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "40px",
    },
  },
  HeadersTextNo: {
    textAlign: "right",
    fontSize: "20px",
    marginTop: "15px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "40px",
    },
  },

  DivCoverReturn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  DivCoverForm: {
    position: "absolute",
    zIndex: "1",
    paddingBottom: "30px",
  },
  Grid: {
    marginTop: "10px",
  },
  Button: {
    width: "100px",
    height: "50px",
    fontSize: "18px",
    color: "white",
    backgroundColor: "green",
    ["&:hover"]: {
      backgroundColor: "darkgreen",
    },
  },
}));

export const DivContent = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "1100px",
  padding: "10px",
  marginBottom: "50px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const DivCoverReturn = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "20px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
}));

export const TextMainTopic = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "bold",
  marginBottom: "5px",
  color: theme.palette.text.primary,
}));

export const DivHead = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const BackButton = styled(IconButton)(({ theme }) => ({
  color: "black",
  fontSize: "20px",
}));

const EditDetailDeliverySampleShuttle = (props) => {
  const classes = useStylesDeliverySampleForm();
  const { enqueueSnackbar } = useSnackbar();
  const booking = props.location.state.booking;

  const formatDateToLocal = (dateString, offset) => {
    const date = new Date(dateString);
    date.setHours(date.getHours() + offset);
    return date.toISOString().slice(0, 16);
  };

  const convertToISO = (localDateStr) => {
    const local = new Date(localDateStr);
    return local.toISOString();
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    getValues,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      idDriver: booking.idDriver || null,
      sendDate:
        booking.status === "ส่งสินค้าเรียบร้อย" ||
        booking.status === "ได้รับสินค้าเรียบร้อย"
          ? booking.sendDate
            ? formatDateToLocal(booking.sendDate, 7)
            : new Date()
          : null,
      completedDate:
        booking.status === "ได้รับสินค้าเรียบร้อย"
          ? booking.completedDate
            ? formatDateToLocal(booking.completedDate, 7)
            : new Date()
          : null,
    },
  });

  const [openDetailBooking, setOpenDetailBooking] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState({
    attachment: null,
  });
  const [lastNo, setLastNo] = useState(0);
  const [newDate, setDate] = useState(
    new Date().toJSON().slice(0, 10).split("-").reverse().join("")
  );

  const { result: allDriver } = useSelector((state) => state.drivers);
  const { result: allEmployees } = useSelector((state) => state.employees);
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: currentUserProfile } = useSelector(
    (state) => state.userProfile
  );
  const [allSite, setAllSite] = useState([]);
  const [sender, setSender] = useState(null);
  const [recipient, setRecipient] = useState(null);

  const onSubmitHandler = (date) => {
    setOpenDetailBooking(true);
  };

  const onCloseDialog = () => {
    setOpenDetailBooking(false);
  };

  useEffect(() => {
    if (props.location.state === undefined) {
      props.history.push("/admin/car_management");
    }
  }, [props.location.state.booking]);

  const onClickSubmit = async () => {
    const myData = {
      UserType: "admin",
      IdUser: getValues("idSender"),
      IdDriver: getValues("idDriver"),
      NameDriver: getValues("nameDriver"),
      NameSample: getValues("nameSample"),
      NameGrade: getValues("nameGrade"),
      LotNumber: getValues("lotNumber"),
      idSender: getValues("idSender"),
      NameSender: getValues("nameSender"),
      PhoneSender: getValues("phoneSender"),
      date: getValues("date"),
      startTime: getValues("startTime"),
      fromPlace: getValues("fromPlace"),
      toPlace: getValues("toPlace"),
      idRecipient: getValues("idRecipient"),
      NameRecipient: getValues("nameRecipient"),
      PhoneRecipient: getValues("phoneRecipient"),
      detail: getValues("detail"),
      status: getValues("status"),
      attachment: getValues("attachment"),
      no: `Carlab${newDate}${lastNo}`,
      deleteOldFile: getValues("deleteOldFile"),
      sendDate: getValues("sendDate") ? convertToISO(getValues("sendDate")) : null,
      completedDate: getValues("completedDate")
        ? convertToISO(getValues("completedDate"))
        : null,
    };

    const formData = new FormData();
    formData.append("mydata", JSON.stringify(myData));
    myData.attachment?.map((file, index) => {
      formData.append(`attachment`, file);
    });

    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    const id = booking.idDeliverySampleShuttle;
    deliverySampleshuttleService
      .postEditDeliverySampleshuttle(formData, id)
      .then((res) => {
        if (res.type === "success") {
          enqueueSnackbar("Edit data Success", { variant: "success" });
          props.history.push("/admin/car_management/delivery_sample_shuttle");
          if (props.formData) {
            dispatch(getDeliverySampleshuttleByAdminFilter(props.formData));
          }
        } else {
          enqueueSnackbar("Edit data Failed", { variant: "error" });
        }
      });
  };

  useEffect(() => {
    if (
      !["ส่งสินค้าเรียบร้อย", "ได้รับสินค้าเรียบร้อย"].includes(watch("status"))
    ) {
      setValue("sendDate", null);
    }
    if (
      ![
        "รับสินค้าเรียบร้อย",
        "ส่งสินค้าเรียบร้อย",
        "ได้รับสินค้าเรียบร้อย",
      ].includes(watch("status"))
    ) {
      setValue("driver", null);
    }
    if (watch("status") !== "ได้รับสินค้าเรียบร้อย") {
      setValue("completedDate", null);
    }
  }, [watch("status"), setValue]);

  useEffect(async () => {
    const dataRe = dispatch(getDeliverySampleShuttleByNo());
    const data = dataRe.then((res) => {
      if (res.data) {
        if (res.data[0].no === null) {
          setLastNo("0001");
        } else {
          const date = res.data[0].no.slice(6, 14);

          var year = date.substring(0, 2);
          var month = date.substring(2, 4);
          var day = date.substring(4, 8);
          var data = new Date(day, month - 1, year);
          var data_date = [
            data.getFullYear(),
            data.getMonth() + 1,
            data.getDate(),
          ].join("-");
          if (data_date === new Date().toJSON().slice(0, 10)) {
            const no = parseInt(res.data[0].no.slice(14, 18)) + 1;
            setLastNo(String(no).padStart(4, "0"));
          } else {
            setLastNo("0001");
          }
        }
      }
    });
    SiteService.getAllSiteLocations().then((res) => {
      if (res.data) {
        setAllSite(res.data);
      }
    });
    if (!allEmployees) {
      await employeeService.getEmployeesById(currentUser.idUser).then((res) => {
        if (res.data) {
          dispatch(getEmployeesByCompany(res.data[0].idCompany));
        }
      });
    }
    if (!allDriver) {
      await userService.getAllDriver(currentUser.idUser);
    }
    if (!currentUserProfile) {
      const curData = await dispatch(getUserProfile(currentUser.idUser));
    }
    await userService.getUserProfile(booking.idSender).then((res) => {
      if (res.data) {
        setSender(res.data);
        console.log(sender);
        setValue("idSender", res.data.idEmployees);
        setValue("nameSender", booking.nameSender);
      }
    });
    await userService.getUserProfile(booking.idRecipient).then((res) => {
      if (res.data) {
        setRecipient(res.data);
        setValue("idRecipient", res.data.idEmployees);
        setValue("nameRecipient", booking.nameRecipient);
      }
    });
    setValue("fromPlaceName", booking.fromPlaceName);
    setValue("toPlaceName", booking.toPlaceName);
    if (booking.idDriver && allDriver) {
      setValue(
        "nameDriver",
        allDriver.find((driver) => driver.idUser === watch("idDriver")).FullName
      );
    }
  }, []);

  return (
    booking && (
      <DivCoverReturn>
        <DivContent>
          <DivHead>
            <BackButton onClick={() => props.history.goBack()}>
              <ArrowBackIosNewIcon />
            </BackButton>
            <Typography className={`${classes.Title}`}>
              แก้ไขรายการรถรับส่งตัวอย่างการทดลอง
            </Typography>
            <div></div>
          </DivHead>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextMainTopic>
              งานที่ Carlab{newDate}
              {lastNo}
            </TextMainTopic>
          </div>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Grid container spacing={0}>
              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",

                  borderRadius: "15px",
                  [theme.breakpoints.down("sm")]: {},
                  [theme.breakpoints.down("md")]: {},
                })}
              >
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <TextMainTopic>รายละเอียดตัวอย่างการทดลอง</TextMainTopic>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    name="nameSample"
                    error={errors.nameSample ? true : false}
                    helperText={
                      errors.nameSample ? "กรุณากรอกชื่อตัวอย่าง" : false
                    }
                    label="ชื่อตัวอย่าง"
                    placeholder="ระบุชื่อตัวอย่าง"
                    fullWidth
                    inputProps={{
                      ...register("nameSample", { required: true }),
                    }}
                    InputProps={{
                      style: {
                        borderRadius: "15px",
                      },
                    }}
                    defaultValue={booking.nameSample}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Grade"
                    placeholder="ระบุGrade"
                    fullWidth
                    inputProps={{ ...register("nameGrade") }}
                    InputProps={{
                      style: {
                        borderRadius: "15px",
                      },
                    }}
                    defaultValue={booking.nameGrade}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Lot Number"
                    placeholder="ระบุLot Number"
                    fullWidth
                    inputProps={{ ...register("lotNumber") }}
                    InputProps={{
                      style: {
                        borderRadius: "15px",
                      },
                    }}
                    defaultValue={booking.lotNumber}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="รายละเอียดเพิ่มเติม"
                    placeholder="ระบุรายละเอียด"
                    variant="outlined"
                    multiline
                    rows={3}
                    getValues
                    fullWidth
                    inputProps={{ ...register("detail") }}
                    InputProps={{
                      style: {
                        borderRadius: "15px",
                      },
                    }}
                    defaultValue={booking.detail}
                  />
                </Grid>
                <Grid item xs={12} lg={12} className="gridContainer">
                  <Grid item xs={4} md={4} lg={7}>
                    <Typography>เพิ่มไฟล์</Typography>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <Dropfile
                      title="แนบไฟล์ (ไม่เกิน 10 MB ต่อไฟล์ สูงสุด 10 ไฟล์)"
                      name="attachment"
                      setValue={setValue}
                      isEdit={true}
                      oldFile={booking.path}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",

                  borderRadius: "15px",
                  [theme.breakpoints.down("sm")]: {},
                  [theme.breakpoints.down("md")]: {},
                })}
              >
                <Grid item xs={12}>
                  <TextMainTopic>รายละเอียดผู้ส่ง</TextMainTopic>
                </Grid>

                {allEmployees &&
                  currentUserProfile &&
                  // (!isEdit || sender !== null) && (
                  sender !== null && (
                    <>
                      <Grid item xs={12} sm={6} lg={4}>
                        <Controller
                          render={(propsInController) => (
                            <Autocomplete
                              options={allEmployees}
                              getOptionLabel={(option) =>
                                `${option.firstname_TH} ${option.lastname_TH}`
                              }
                              isOptionEqualToValue={(option, value) =>
                                option === value
                              }
                              renderOption={(props, option) => (
                                <Box component="li" {...props}>
                                  {`${option.firstname_TH} ${option.lastname_TH}`}
                                </Box>
                              )}
                              value={propsInController.field.value}
                              onChange={(e, value) => {
                                if (value) {
                                  setValue("idSender", value.idEmployees);
                                  setValue(
                                    "nameSender",
                                    `${value.firstname_TH} ${value.lastname_TH}`
                                  );
                                  setValue(
                                    "phoneSender",
                                    value.telephoneMobile
                                  );
                                  propsInController.field.onChange(value);
                                  console.log(
                                    `nameSender: ${value.firstname_TH} ${value.lastname_TH}`
                                  );
                                  console.log(`idSender: ${value.idEmployees}`);
                                  console.log(
                                    `phoneSender: ${value.telephoneMobile}`
                                  );
                                } else {
                                  setValue("idSender", null);
                                  setValue("nameSender", "");
                                  setValue("phoneSender", "");

                                  propsInController.field.onChange(null);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="nameSender"
                                  error={errors.Sender ? true : false}
                                  helperText={
                                    errors.Sender
                                      ? "กรุณากรอกชื่อผู้ส่ง"
                                      : false
                                  }
                                  placeholder="ระบุชื่อ-นามสกุล"
                                  label="ชื่อผู้ส่ง"
                                  fullWidth
                                  defaultValue={booking.nameSender}
                                  sx={{
                                    ".MuiInputBase-root": {
                                      borderRadius: "15px",
                                    },
                                  }}
                                />
                              )}
                            />
                          )}
                          name="Sender"
                          control={control}
                          rules={{ required: true }}
                          defaultValue={sender}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} lg={4}>
                        <Controller
                          render={(propsInController) => (
                            <TextField
                              name="phoneSender"
                              error={errors.phoneSender ? true : false}
                              InputLabelProps={{
                                shrink:
                                  getValues("phoneSender") === "" ||
                                  getValues("phoneSender") === null ||
                                  getValues("phoneSender") === undefined
                                    ? false
                                    : true,
                              }}
                              helperText={
                                errors.phoneSender
                                  ? "กรุณากรอกเบอร์โทรผู้ส่ง"
                                  : false
                              }
                              placeholder="ระบุเบอร์โทรผู้ส่ง"
                              label="เบอร์โทรผู้ส่ง"
                              fullWidth
                              inputProps={{
                                ...register("phoneSender", { required: true }),
                              }}
                              value={propsInController.field.value}
                              InputProps={{
                                style: {
                                  borderRadius: "15px",
                                },
                              }}
                            />
                          )}
                          name="phoneSender"
                          control={control}
                          rules={{ required: true }}
                          defaultValue={booking.phoneSender}
                        />
                      </Grid>
                    </>
                  )}
                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"จุดรับของต้นทาง"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          name="fromPlace"
                          error={errors.fromPlace ? true : false}
                          helperText={
                            errors.fromPlace
                              ? "กรุณาเลือกจุดรับของต้นทาง"
                              : false
                          }
                          label="จุดรับของต้นทาง"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            setValue(
                              "fromPlaceName",
                              allSite.map((value) => {
                                if (value.idScgSite === e.target.value) {
                                  if (value.noSite !== null) {
                                    return `Site${value.noSite}: ${value.nameSite}`;
                                  } else {
                                    return `${value.nameSite}`;
                                  }
                                }
                              })
                            );

                            propsInController.field.onChange(e);
                            // handleChange(e);
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          {allSite.map((value, index) => (
                            <MenuItem key={index} value={value.idScgSite}>
                              {value.noSite !== null &&
                                `Site${value.noSite}:${value.nameSite}`}
                              {value.noSite === null && `${value.nameSite}`}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                      name="fromPlace"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={booking.fromPlace}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={thLocale}
                  >
                    <Controller
                      name="date"
                      control={control}
                      defaultValue={
                        booking.date ? new Date(booking.date) : null
                      }
                      render={({ field }) => (
                        <DatePicker
                          label="วันที่ส่ง"
                          value={field.value}
                          onChange={(date) => field.onChange(date)}
                          inputFormat="dd/MM/yyyy"
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                ".MuiInputBase-root": { borderRadius: "15px" },
                              }}
                              fullWidth
                              {...params}
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                  <Controller
                    render={(propsInController) => (
                      <FormControl fullWidth>
                        <InputLabel shrink>{"เวลารับของต้นทาง"}</InputLabel>
                        <Select
                          native
                          label="เวลารับของต้นทาง"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            propsInController.field.onChange(e.target.value);
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          {[...new Array(48)].map((value, index) => {
                            let hour = Math.floor((0 + index * 30) / 60);
                            let minute = Math.floor((0 + index * 30) % 60);
                            if (hour < 10) {
                              hour = "0" + hour;
                            }
                            if (minute < 10) {
                              minute = "0" + minute;
                            }
                            return (
                              <option
                                value={hour + ":" + minute}
                                key={hour + ":" + minute}
                              >
                                {hour + ":" + minute}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                    name="startTime"
                    control={control}
                    defaultValue={booking.startTime}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",

                  borderRadius: "15px",
                  [theme.breakpoints.down("sm")]: {},
                  [theme.breakpoints.down("md")]: {},
                })}
              >
                <Grid item xs={12}>
                  <TextMainTopic>รายละเอียดผู้รับ</TextMainTopic>
                </Grid>
                {allEmployees && currentUserProfile && recipient !== null && (
                  <>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Controller
                        render={(propsInController) => (
                          <Autocomplete
                            options={allEmployees}
                            getOptionLabel={(option) =>
                              `${option.firstname_TH} ${option.lastname_TH}`
                            }
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            renderOption={(props, option) => (
                              <Box component="li" {...props}>
                                {`${option.firstname_TH} ${option.lastname_TH}`}
                              </Box>
                            )}
                            value={propsInController.field.value}
                            onChange={(e, value) => {
                              if (value) {
                                setValue("idRecipient", value.idEmployees);
                                setValue(
                                  "nameRecipient",
                                  `${value.firstname_TH} ${value.lastname_TH}`
                                );
                                setValue(
                                  "phoneRecipient",
                                  value.telephoneMobile
                                );
                                propsInController.field.onChange(value);
                                console.log(
                                  `nameRecipient: ${value.firstname_TH} ${value.lastname_TH}`
                                );
                                console.log(
                                  `idRecipient: ${value.idEmployees}`
                                );
                                console.log(
                                  `phoneRecipient: ${value.telephoneMobile}`
                                );
                              } else {
                                setValue("idRecipient", null);
                                setValue("nameRecipient", "");
                                setValue("phoneRecipient", "");

                                propsInController.field.onChange(null);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="nameRecipient"
                                error={errors.Recipient ? true : false}
                                helperText={
                                  errors.Recipient
                                    ? "กรุณากรอกชื่อผู้รับ"
                                    : false
                                }
                                placeholder="ระบุชื่อ-นามสกุล"
                                label="ชื่อผู้รับ"
                                fullWidth
                                defaultValue={booking.nameRecipient}
                                sx={{
                                  ".MuiInputBase-root": {
                                    borderRadius: "15px",
                                  },
                                }}
                              />
                            )}
                          />
                        )}
                        name="Recipient"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={recipient}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={4}>
                      <Controller
                        render={(propsInController) => (
                          <TextField
                            name="phoneRecipient"
                            error={errors.phoneRecipient ? true : false}
                            InputLabelProps={{
                              shrink:
                                getValues("phoneRecipient") === "" ||
                                getValues("phoneRecipient") === null ||
                                getValues("phoneRecipient") === undefined
                                  ? false
                                  : true,
                            }}
                            helperText={
                              errors.phoneRecipient
                                ? "กรุณากรอกเบอร์โทรผู้รับ"
                                : false
                            }
                            placeholder="ระบุเบอร์โทรผู้รับ"
                            label="เบอร์โทรผู้รับ"
                            fullWidth
                            inputProps={{
                              ...register("phoneRecipient", { required: true }),
                            }}
                            value={propsInController.field.value}
                            InputProps={{
                              style: {
                                borderRadius: "15px",
                              },
                            }}
                          />
                        )}
                        name="phoneRecipient"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={booking.phoneRecipient}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"จุดส่งของ"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          name="toPlace"
                          label="จุดส่งของ"
                          value={propsInController.field.value}
                          error={errors.toPlace ? true : false}
                          helperText={
                            errors.toPlace ? "กรุณาเลือกจุดส่งของ" : false
                          }
                          onChange={(e) => {
                            setValue(
                              "toPlaceName",
                              allSite.map((value) => {
                                if (value.idScgSite === e.target.value) {
                                  if (value.noSite !== null) {
                                    return `Site${value.noSite}: ${value.nameSite}`;
                                  } else {
                                    return `${value.nameSite}`;
                                  }
                                }
                              })
                            );
                            propsInController.field.onChange(e);
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          {allSite.map((value, index) => (
                            <MenuItem key={index} value={value.idScgSite}>
                              {value.noSite !== null &&
                                `Site${value.noSite}:${value.nameSite}`}
                              {value.noSite === null && `${value.nameSite}`}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                      name="toPlace"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={booking.toPlace}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid
                container
                item
                spacing={3}
                xs={12}
                sx={(theme) => ({
                  display: "flex",
                  boxShadow:
                    "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
                  border: "1px solid #EEEEEE",
                  backgroundColor: "#FBFCFC",
                  marginTop: "10px",
                  marginBottom: "20px",
                  marginLeft: "0px",
                  padding: "0 25px 25px 0",
                  width: "100%",
                  borderRadius: "15px",
                })}
              >
                <Grid item xs={12}>
                  <TextMainTopic>สถานะการส่งของ</TextMainTopic>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{"สถานะ"}</InputLabel>
                    <Controller
                      render={(propsInController) => (
                        <Select
                          label="สถานะ"
                          value={propsInController.field.value}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setValue("status", newValue);
                            propsInController.field.onChange(e);
                            if (booking.status === "รอรับสินค้า") {
                              if (newValue === "รอรับสินค้า") {
                                setValue("idDriver", null);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "รับสินค้าเรียบร้อย") {
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "ส่งสินค้าเรียบร้อย") {
                                setValue("completedDate", null);
                              }
                            }
                            // have driver
                            else if (booking.status === "รับสินค้าเรียบร้อย") {
                              if (newValue === "รอรับสินค้า") {
                                setValue("idDriver", null);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "รับสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "ส่งสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue("completedDate", null);
                              } else {
                                setValue("idDriver", booking.idDriver);
                              }
                            }
                            // have sendDate && driver
                            else if (booking.status === "ส่งสินค้าเรียบร้อย") {
                              if (newValue === "รอรับสินค้า") {
                                setValue("idDriver", null);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "รับสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "ส่งสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue(
                                  "sendDate",
                                  formatDateToLocal(booking.sendDate, 7)
                                );
                                setValue("completedDate", null);
                              } else {
                                setValue(
                                  "sendDate",
                                  formatDateToLocal(booking.sendDate, 7)
                                );
                                setValue("idDriver", booking.idDriver);
                              }
                            }
                            // have sendDate && driver && completedDate
                            else {
                              if (newValue === "รอรับสินค้า") {
                                setValue("idDriver", null);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "รับสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue("sendDate", null);
                                setValue("completedDate", null);
                              } else if (newValue === "ส่งสินค้าเรียบร้อย") {
                                setValue("idDriver", booking.idDriver);
                                setValue(
                                  "sendDate",
                                  formatDateToLocal(booking.sendDate, 7)
                                );
                                setValue("completedDate", null);
                              } else {
                                setValue(
                                  "completedDate",
                                  formatDateToLocal(booking.completedDate, 7)
                                );
                                setValue(
                                  "sendDate",
                                  formatDateToLocal(booking.sendDate, 7)
                                );
                                setValue("idDriver", booking.idDriver);
                              }
                            }
                          }}
                          style={{ borderRadius: "15px" }}
                        >
                          <MenuItem value={"รอรับสินค้า"}>รอรับสินค้า</MenuItem>
                          <MenuItem value={"รับสินค้าเรียบร้อย"}>
                            รับสินค้าเรียบร้อย
                          </MenuItem>
                          <MenuItem value={"ส่งสินค้าเรียบร้อย"}>
                            ส่งสินค้าเรียบร้อย
                          </MenuItem>
                          <MenuItem value={"ได้รับสินค้าเรียบร้อย"}>
                            ได้รับสินค้าเรียบร้อย
                          </MenuItem>
                        </Select>
                      )}
                      name="status"
                      control={control}
                      defaultValue={booking.status}
                    />
                  </FormControl>
                </Grid>

                {["ส่งสินค้าเรียบร้อย", "ได้รับสินค้าเรียบร้อย"].includes(
                  watch("status")
                ) && (
                  <Grid item xs={12} sm={6} lg={4}>
                    <TextField
                      name="sendDate"
                      fullWidth
                      label="วัน-เวลา ส่งสินค้าสำเร็จ"
                      type="datetime-local"
                      InputProps={{
                        style: {
                          borderRadius: "15px",
                        },
                      }}
                      defaultValue={
                        watch("sendDate") ||
                        formatDateToLocal(booking.sendDate, 7)
                      }
                      InputLabelProps={{ shrink: true }}
                      {...register("sendDate", { required: true })}
                    />
                  </Grid>
                )}

                {watch("status") === "ได้รับสินค้าเรียบร้อย" && (
                  <Grid item xs={12} sm={6} lg={4}>
                    <TextField
                      name="completedDate"
                      fullWidth
                      label="วัน-เวลา ยืนยันการรับสินค้า"
                      type="datetime-local"
                      InputProps={{
                        style: {
                          borderRadius: "15px",
                        },
                      }}
                      defaultValue={
                        watch("completedDate") ||
                        (booking.completedDate
                          ? formatDateToLocal(booking.completedDate, 7)
                          : new Date())
                      }
                      InputLabelProps={{ shrink: true }}
                      {...register("completedDate", { required: true })}
                    />
                  </Grid>
                )}

                {[
                  "รับสินค้าเรียบร้อย",
                  "ส่งสินค้าเรียบร้อย",
                  "ได้รับสินค้าเรียบร้อย",
                ].includes(watch("status")) &&
                  allDriver && (
                    <Grid item xs={12} sm={6} lg={4}>
                      <Autocomplete
                        options={allDriver}
                        getOptionLabel={(option) => option.FullName}
                        value={
                          allDriver.find(
                            (driver) => driver.idUser === watch("idDriver")
                          ) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="idDriver"
                            placeholder="ระบุชื่อ-นามสกุล"
                            label="ชื่อคนขับรถ"
                            fullWidth
                            sx={{
                              ".MuiInputBase-root": {
                                borderRadius: "15px",
                              },
                            }}
                            required={true}
                          />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setValue("idDriver", value.idUser);
                            setValue("nameDriver", value.FullName);
                          }
                        }}
                      />
                    </Grid>
                  )}
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "20px",
                }}
              >
                <div className={`${classes.NavButton}`}>
                  <Button className={`${classes.Button}`} type="submit">
                    ยืนยัน
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>

          {openDetailBooking && (
            <DialogShowDetailDialog
              open={openDetailBooking}
              handleClose={onCloseDialog}
              getValues={getValues}
              onClickSubmit={onClickSubmit}
            />
          )}
        </DivContent>
      </DivCoverReturn>
    )
  );
};

export default EditDetailDeliverySampleShuttle;
